import React, { useContext, useState } from "react";


import TextField from "../Form/TextField";
import EmailField from "../Form/EmailField";
import PasswordFiled from "../Form/PasswordField";
import SubmitField from "../Form/SubmitField";
import { useFormik } from "formik";
import * as yup from "yup";
import Swal from 'sweetalert2'

import CountryField from "../Form/CountryField";
import { countries } from "../countries";

import {
  cityValidation,
  countryValidation,
  emailValidation,
  firstNameValidation,
  lastNameValidation,
  passwordValidation,
  phoneValidation,
  provinceValidation,
} from "../../utils/validation";
import { rootContexts } from "../../contexts/rootContexts";
import {
  authSignup,
  authSignupOtp,
  authverificationType,
} from "../../services/authService";
import { ClipLoader } from "react-spinners";
import { PhoneField } from "../Form";

// import errorModel from '../Errors/ErrorModel';

export default function Signup() {
  
  const [loader, setLoader] = useState(false);
  const [idotp, setIdotp] = useState("");
  const [email_otp, setEmail_otp] = useState("");
  const [varify_type, setvarify_type] = useState(false);
  const [issignup, setIssignup] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [serverError, setServerError] = useState({});
  const [verifyMessage, setverifyMessage] = useState("");
  const [countryCode, seCountryCode] = useState("");
  const [asAgreed, setAsAgreed] = useState(false);
  const [otpServerError, setOtpServerError] = useState(false);
  const [otpVerifyError, setOtpVerifyError] = useState(false);
  const { setAsLogin } = useContext(rootContexts);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      phone: "",
      cpassword: "",
      first_name: "",
      last_name: "",
      country: "",
      city: "",
      province: "",

      //creationDate:
    },
    validationSchema: yup.object({
      email: emailValidation,
      phone: phoneValidation,
      city: cityValidation,
      province: provinceValidation,
      password: passwordValidation,
      first_name: firstNameValidation,
      last_name: lastNameValidation,
      country: countryValidation,

      cpassword: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .required("Please confirm your password"),
    }),
    onSubmit: async (values) => {
   
      setLoader(true);
      const result = await authSignup(values);
  
      if (result.status) {
       
        setIdotp(result.data.id);
        // setAsLogin(false);
        setIssignup(true);
        setLoader(false);
      } else {
       
        setServerError(result.errors)
       
        
        setLoader(false);
        setLoader(false);
        setIssignup(false);
        //  errorModel('error',result.message)
      }
    },
  });

  

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    if(event.target.value=="phone"){
      setverifyMessage("Please enter your verification code to complete the process. We sent you a verification code via SMS.")
    }
    else{
      setverifyMessage("Please enter your verification code to complete the process. We sent you a verification code via Email.")
    }
   
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    const result = await authverificationType(idotp, selectedOption);
    if (result.status) {
      setvarify_type(true);
      setLoader(false);
    }
    else{
      setLoader(false);
      setOtpServerError("Oops! It looks like we're experiencing some technical difficulties at the moment. We apologize for the inconvenience. Please try again later or reach out to our support team for assistance. Thank you for your patience.")
    }

  };

  const handleSubmitVarifacation = async (e) => {
    e.preventDefault();
 
    const SignupOtp = await authSignupOtp(email_otp, idotp, selectedOption);
   
    setLoader(true);
    if (SignupOtp.status === true) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Congrats! You've successfully registered your account  on LMIA.LTD!",
      });
      setAsLogin(false);
      setLoader(false);
    } else {
     
      setOtpVerifyError(SignupOtp.message)
      setLoader(false);
    }
  };
  // const get international code  start
  const handleCountry=(e)=>{
    
    formik.handleChange(e)
    
    const countryCode=countries.filter((country)=> country.name.includes(e.target.value))
    if(countryCode.length>0){
      seCountryCode(countryCode[0].code.toUpperCase())
      formik.setFieldValue('phone',"")
    }
   
  }
  // const get international code  start
  
  return (
    <>
      {issignup ? (
        <div className=" border-2 border-beta p-4 rounded mt-5">
          <h1 className="h2 text-center py-4">Verify Your Account</h1>
          {otpServerError ?
          <div className="p-1 rounded shadow-orange-600 bg-orange-400 text-white">
            {otpServerError}
          </div> : null }
          {varify_type ? (
            <form
              onSubmit={handleSubmitVarifacation}
              className="px-5 md:px-10 space-y-3"
              id="otp"
            >
                <p className="text-sm">{verifyMessage}</p>
              <div className="grid grid-cols-2 gap-y-0 gap-x-4 ">
                <div>
                  <input
                    className="py-4 px-3 bg-[#E4E6E3] w-full border-none  placeholder:text-[#494949] focus:text-[#494949] focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima"
                    onChange={(e) => setEmail_otp(e.target.value)}
                    placeholder="Verification Code"
                  />
                  {otpVerifyError ? <span className="text-red-500 text-xs">{otpVerifyError}</span>: null}
                </div>
                <div className="">
                  <button
                    className="bg-primary hover:bg-info/90 text-white block py-4 px-4 text-center w-full font-imprima "
                    type="submit"
                  >
                    Verify{" "}
                    <ClipLoader
                      color={"#ffffff"}
                      loading={loader}
                      // cssOverride={override}
                      size={15}
                      className="relative top-1 left-2"
                      aria-label="Loading "
                      data-testid="loader"
                    />
                  </button>
                </div>
                
              </div>
            </form>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="my-2 px-4">
                <label className="block font-bold my-2">Choose an option:</label>
                <div className="flex items-center mb-2">
                  <input
                    type="radio"
                    id="email"
                    name="options"
                    value="email"
                    checked={selectedOption === "email"}
                    onChange={handleOptionChange}
                    className="mr-2"
                    required
                  />
                  <label for="option1">Email</label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    id="phone"
                    name="options"
                    value="phone"
                    checked={selectedOption === "phone"}
                    onChange={handleOptionChange}
                    className="mr-2"
                    required
                  />
                  <label for="option2">Phone No.</label>
                </div>
              </div>
              {/* <div className="flex justify-center my-2">
          <button onClick={handleSubmit} className="bg-primary hover:bg-info/90 text-white block py-2 px-4 text-center w-50 font-imprima ">Submit</button>
         
        </div> */}
              <div
                // onClick={handleSubmit}
                className="flex justify-center py-2 px-4"
              >
                <SubmitField label="Submit" loader={loader} />
              </div>
            </form>
          )}
        </div>
      ) : (
        <div className=" border-2 border-beta p-4 rounded mt-5">
          <h1 className="h2 text-center py-4">Create Account</h1>

          <form
            onSubmit={formik.handleSubmit}
            className="px-5 md:px-10 space-y-3"
          >
            <div className="grid grid-cols-2 gap-y-0 gap-x-4 ">
              <div>
                <TextField
                  name="first_name"
                  placeholder="First Name"
                  formik={formik}
                />
              </div>
              <div>
                <TextField
                  name="last_name"
                  placeholder="Last Name"
                  formik={formik}
                />
              </div>
            </div>
            <div className="py-4">
              <CountryField
                name="country"
                placeholder="Confirm Password"
                formik={formik}
                handleCountry={handleCountry}
              />
            </div>
            <div>
              <TextField
                name="province"
                placeholder="Province"
                formik={formik}
              />
            </div>
            <div>
              <TextField name="city" placeholder="City" formik={formik} />
            </div>
            <div>
              <PhoneField name="phone" placeholder="Phone no." formik={formik} code={countryCode} />
              <span className="text-red-500">
              {serverError?.phone ? serverError.phone[0] :null}
            </span>
            </div>
            <div>
            <EmailField name="email" placeholder="Email" formik={formik} />
            <span className="text-red-500">
              {serverError?.email ? serverError.email[0] :null}
            </span>
            </div>
             
            <PasswordFiled
              name="password"
              placeholder="Password"
              formik={formik}
            />

            <PasswordFiled
              name="cpassword"
              placeholder="Confirm Password"
              formik={formik}
            />
         
        
           
          
           
            <div className="py-2 font-imprima flex items-center space-x-4">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                onChange={()=>setAsAgreed(true)}
                onBlur={formik.handleBlur}
                className="bg-[#E4E6E3] border-2 border-beta checked:bg-beta checked:ring-beta px-3 py-3"
                required
               
              />
              <label htmlFor="terms text-info">
                I agree to{" "}
                <a href="/terms-and-conditions" target="_blank"  className="underline">
                  {" "}
                  Terms and Conditions
                </a>{" "}
              </label>
            </div>
            {formik.touched.terms && formik.errors.terms && (
              <div className=" pt-3 text-[12px] text-red-600 ">
                {formik.errors.terms}
              </div>
            )}
            <div className=" py-2">
              <SubmitField label="Register" loader={loader} />
            </div>
          </form>
        </div>


      )}

    </>
  );
}
